import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { SphereTypes } from "../../../generated/graphql";

interface SphereSelectProps {
  sphere: string;
  handleSetSphere: (value: SphereTypes) => void;
  disabled?: boolean;
}

export const SphereTypesSelect = ({
  sphere,
  handleSetSphere,
  disabled = false,
}: SphereSelectProps) => {
  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="sphere-select-label">Оберіть sphere type</InputLabel>
      <Select
        labelId="sphere-select-label"
        value={sphere}
        onChange={(e) => handleSetSphere(e.target.value as SphereTypes)}
      >
        <MenuItem value="">— Not selected —</MenuItem>
        {Object.values(SphereTypes).map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
